<template>
  <div class="personInfos">
    <h1 v-if="personI">个人信息</h1>
    <div class="infosPhoto" v-if="personI">
      <p>头像</p>
      <el-upload class="avatar-uploader" name="avatar" :action="action" :show-file-list="false" :limit="1" :on-success="handleAvatarSuccess">
        <img v-if="userInfo.avatar_url" :src="$headImgUrl" class="avatar" />
        <!-- <img :src="userinfo.avatar_url==='/static/img/avatar_photo.png'?$headImgUrl:userinfo.avatar_url" class="avatar" /> -->
      </el-upload>
    </div>
    <div class="infosCell" v-if="personI">
      <div class="cellBlock">
        <a>昵称</a>
        <input type="text" v-model="userInfo.nick" class="userNames" :disabled="disabledName" :style="{ border: nameBorder }" />
        <div class="cellNickname" @click="editUserName" v-if="showName">
          <img src="@/assets/accountSeting/editIcon.png" />
          <span>修改</span>
        </div>
        <div class="cellNickname" style="display: none">
          <img src="@/assets/accountSeting/reminIcon.png" />
          <span>昵称不能重复</span> 
        </div>
        <!-- <input class="editNames" type="text" > -->
        <div class="editBtns" v-if="editName">
          <button @click="editUserNameT">保存</button>
          <button @click="cancleName">取消</button>
        </div>
      </div>
      <div class="cellBlock">
        <a>性别</a>
        <span v-if="showGender">{{userInfo.gender | sexVal}}</span>
        <div class="cellNickname" @click="editGenders" v-if="showGender">
          <img src="@/assets/accountSeting/editIcon.png" />
          <span>修改</span>
        </div>
        <span v-if="editGender">
          <el-radio v-model="userInfo.gender" :label="sex.value" v-for="(sex,insex) in sexList" :key="insex">{{sex.label}}</el-radio>
        </span>
        <div class="editBtns" v-if="editGender">
          <button @click="editGenderT">保存</button>
          <button @click="editGenderF">取消</button>
        </div>
      </div>
      <div class="cellBlock">
        <a>当前职业</a>
        <span class="userNickName" v-if="showVocation">{{userInfo.job | filterCanner}}</span>
        <div class="cellNickname" @click="editVocat" v-if="showVocation">
          <img src="../../assets/accountSeting/editIcon.png" />
          <span>修改</span>
        </div>
        <el-select v-model="userInfo.job" placeholder="请选择" v-if="editVocation" style="margin-left: 50px">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div class="editBtns" v-if="editVocation">
          <button @click="editVocaT">保存</button>
          <button @click="editVocaF">取消</button>
        </div>
      </div>
      <div class="cellBlock">
        <a>考试计划</a>
        <span class="cellSpan">{{userInfo.plan}}</span>
        <div class="cellNickname">
          <img src="../../assets/accountSeting/editIcon.png" />
          <span>修改</span>
        </div>
      </div>
      <div class="cellBlock">
        <a>收货地址</a>
        <div class="cellNickname" @click="editAreas">
          <img src="../../assets/accountSeting/editIcon.png" />
          <span>修改</span>
        </div>
      </div>
    </div>
    <!-- 修改地址 -->
    <div class="editAddress" v-if="editArea">
      <div class="editCells">个人信息 > 收货地址</div>
      <div class="editCells">
        <p>收货人</p>
        <input type="text" v-model="takeOver.name" placeholder="请输入收货人姓名" />
      </div>
      <div class="editCells">
        <p>手机号</p>
        <input type="text" v-model="takeOver.phone" placeholder="请输入手机号" />
      </div>
      <div class="editCells">
        <p>所在地区</p>
        <div style="margin-left: 20px">
          <el-select v-model="takeOver.province" placeholder="请选择省份" @change="choiceCity(takeOver.province)">
            <el-option v-for="item in proviceList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="takeOver.city" placeholder="市" @change="choiceArea(takeOver.city)">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="takeOver.county" placeholder="区">
            <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="editCells">
        <p>详细地址</p>
        <input class="inputInfos" type="text" v-model="takeOver.detail" placeholder="道路,门牌号,小区,楼号" />
      </div>
      <div class="keepArea">
        <button @click="keepAddress">保存</button>
        <button @click="cancleAddress">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api/personallnfo.js";
  export default {
    data() {
      return {
        action: 'https://www.scoreupup.com/index/user/avatar',
        disabledName: true, //用户姓名更改
        sexList: [{
            label: '保密',
            value: '0'
          },
          {
            label: '男',
            value: '1'
          },
          {
            label: '女',
            value: '2'
          },
        ],
        //职业选择下拉框
        options: [{
            label: "未选择",
            value: "0"
          },
          {
            label: "学生",
            value: "1"
          },
          {
            label: "上班族",
            value: "2"
          },
          {
            label: "自由职业",
            value: "3"
          },
        ],
        personI: true,
        editArea: false, //详细地址
        editName: false, //修改昵称按钮
        editGender: false, //修改性别按钮
        editVocation: false, //修改职业按钮
        showGender: true, //性别显示值
        showVocation: true, //当前职业
        showName: true,
        nameBorder: "",
        proviceList: [], //省份
        cityList: [], //市
        areaList: [], //区
        //收货地址
        takeOver: {
          name: "",
          phone: "",
          province: "",
          city: "",
          county: "",
          detail: "",
        },
        userInfo: {}
      };
    },
    mounted() {
      this.getInfo()
    },
    filters: {
      sexVal(data) {
        if (data == 0) {
          return '保密'
        } else if (data == 1) {
          return '男'
        } else {
          return '女'
        }
      },
      filterCanner(date) {
        if (date == 0) {
          return '未选择'
        } else if (date == 1) {
          return '学生'
        } else if (date == 2) {
          return '上班族'
        } else {
          return '自由职业'
        }
      }
    },
    methods: {
      //修改昵称
      editUserName() {
        this.disabledName = this.showName = false;
        this.editName = true;
        this.nameBorder = "1px solid #999999";
      },
      //修改昵称 取消按钮
      cancleName() {
        this.disabledName = this.showName = true;
        this.editName = false;
        this.nameBorder = "1px solid #ffffff";
      },
      //修改昵称 确定按钮
      editUserNameT() {
        this.editInfo(this.userInfo)
        this.cancleName();
      },
      //修改职业
      editVocat() {
        this.editVocation = true;
        this.showVocation = false;
      },
      //修改职业 确定按钮
      editVocaT() {
        this.editInfo(this.userInfo)
        this.editVocaF();
      },
      //修改职业 取消按钮
      editVocaF() {
        this.editVocation = false;
        this.showVocation = true;
      },
      //修改收货地址
      editAreas() {
        this.editArea = true;
        this.personI = false;
        this.getAddress();
      },
      //修改收货地址  保存按钮
      keepAddress() {
        if (
          !this.takeOver.name ||
          !this.takeOver.phone ||
          (!this.takeOver.province && !this.takeOver.city) ||
          !this.takeOver.county ||
          !this.takeOver.detail
        ) {
          this.$message.error("请填写完整的收货地址");
          // if(!this.takeOver.name){
          //   this.$message.error('请填写收货人姓名')
          // }
          // if(!this.takeOver.phone){
          //   this.$message.error('请填写收货人手机号')
          // }
          //  if(!this.takeOver.province){
          //   this.$message.error('请选择所在地区省份')
          // }
          //  if(!this.takeOver.city){
          //   this.$message.error('选择所在地区市')
          // }
          //  if(!this.takeOver.county){
          //   this.$message.error('选择所在地区市区')
          // }
          //  if(!this.takeOver.detail){
          //   this.$message.error('选填写收货详细地址')
          // }
        } else {
          const telStr =
            /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
          if (!telStr.test(this.takeOver.phone)) {
            this.$message.error('手机号码格式错误')
          } else {
            this.addaddress(this.takeOver);
          }
        }
      },
      //修改收货地址   取消按钮
      cancleAddress() {
        this.editArea = false;
        this.personI = true;
      },
      //修改性别
      editGenders() {
        this.editGender = true;
        this.showGender = false;
      },
      //修改性别  确定按钮
      editGenderT() {
        this.editGenderF();
        this.editInfo(this.userInfo)
      },
      //修改性别  取消按钮
      editGenderF() {
        this.editGender = false;
        this.showGender = true;
      },
      //用户头像
      handleAvatarSuccess(res, file) {
        this.userInfo.avatar_url = res.data
        this.editInfo(this.userInfo)
      },
      //获取省
      getAddress() {
        api
          .getProvice()
          .then((res) => {
            this.proviceList = res.data.data;
          })
          .catch((err) => {
            this.$message.error("数据获取失败");
          });
      },
      //获取市
      choiceCity(id) {
        let params = {
          id: id,
        };
        let query = this.$qs.stringify(params);
        api
          .getCity(query)
          .then((res) => {
            this.cityList = res.data.data;
          })
          .catch((err) => {
            this.$message.error("数据获取失败");
          });
      },
      //获取区
      choiceArea(id) {
        let params = {
          id: id,
        };
        let query = this.$qs.stringify(params);
        api
          .getArea(query)
          .then((res) => {
            this.areaList = res.data.data;
          })
          .catch((err) => {
            this.$message.error("数据获取失败");
          });
      },
      //收货地址
      addaddress(par) {
        let qs = this.$qs.stringify(par);
        api.address(qs).then((res) => {
          this.cancleAddress();
          for (let i in this.takeOver) {
            this.takeOver[i] = "";
          }
        });
      },
      //修改个人信息
      editInfo(parery) {
        let query = this.$qs.stringify(parery)
        api.editPersonInfo(query).then(res => {
            this.$message.success('修改成功')
            this.getInfo()
          })
          .catch(err => {
            this.$message.error('修改失败')
          })
      },
      //获取个人信息
      getInfo() {
        api.getPersonInfo().then(res => {
            this.userInfo = res.data.data
            this.imageUrl = this.userInfo.avatar_url
          })
          .catch(err => {
            this.$message.error('获取数据失败')
          })
      }
    },
  };
</script>

<style scoped>
  @import '../../assets/css/personalInfos.css';
</style>



// WEBPACK FOOTER //
// src/view/accountSetting/personalInfos.vue